"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = position;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _offset = _interopRequireDefault(require("./offset"));
var _offsetParent = _interopRequireDefault(require("./offsetParent"));
var _scrollTop = _interopRequireDefault(require("./scrollTop"));
var _scrollLeft = _interopRequireDefault(require("./scrollLeft"));
var _style = _interopRequireDefault(require("../style"));
function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}
function position(node, offsetParent) {
  var parentOffset = {
      top: 0,
      left: 0
    },
    offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
  // because it is its only offset parent

  if ((0, _style.default)(node, 'position') === 'fixed') {
    offset = node.getBoundingClientRect();
  } else {
    offsetParent = offsetParent || (0, _offsetParent.default)(node);
    offset = (0, _offset.default)(node);
    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
  } // Subtract parent offsets and node margins

  return (0, _extends2.default)({}, offset, {
    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
  });
}
module.exports = exports["default"];